import { Component } from '@angular/core';

@Component({
  selector: 'app-categories-icon',
  imports: [],
  templateUrl: './categories-icon.html',
  styleUrl: './categories-icon.scss'
})
export class CategoriesIcon {

}
